import { Color } from "@/interface/map";

const colorChart: Color[] = [
  "#006494",
  "#1B98E0",
  "#4361EE",
  "#7209B7",
  // '#F72585',
  "#538D22",
  "#73A942",
  "#3C5A14",
  "#0F5257",
  "#7678ED",
  "#3B0086",
  "#002954",
  "#5A0B4D",
  "#3C1642",
  "#5F3D78",
  // '#EF6351',
  "#2E7CCA",
  "#694F5D",
  "#CC7D2E",
  // '#CC482E',
  "#582F0E",
  "#FCA311",
  "#4F5D75",
  "#7C879C",
  "#3D5A80",
  "#245501",
  "#FF7D00",
  // '#8F250C',
  // '#C33C54',
  // '#F85E00',
  "#FFD400",
  "#333533",
  "#368F8B",
  "#798478",
  // '#AA4465',
  // '#EF233C',
  "#5E503F",
  "#004E98",
  "#5C6BC0",
  // '#64B5F6',
  "#9575CD",
  "#3949AB",
  "#7B1FA2"
];
export function getRandomColor(): Color {
  const random = Math.floor(Math.random() * colorChart.length);
  return colorChart[random];
}
